import type { ChatModeItem, ChatModeValue } from "./api";

const CHAT_MODE_DISPLAY_NAMES: Record<ChatModeValue, string> = {
  0: "秘書モード",
  1: "プライベートモード",
};

export function getChatModeDisplayName(mode: Pick<ChatModeItem, "mode" | "name">): string {
  return CHAT_MODE_DISPLAY_NAMES[mode.mode] ?? mode.name;
}
